// Generated by CoffeeScript 2.7.0
var Phone;

import Base from './base.js';

export default Phone = class Phone extends Base {
  getDisappearedFieldIdsOnInit() {
    return _.pluck(this.logic_rule, 'field_ids');
  }

};
